import type { EvalReport, EvalReportRow } from '@/versions/evalGate';
import type { EvalRunCounts } from '@/repositories/UserRepo';

/** Every query here reads `eval_run` users; invalidating this root refreshes them all. */
export const EVAL_RUNS_ROOT = ['evalRuns'] as const;

/** Every `eval_run` user on one version, by scenario id. Shared by all cells of the selected-version columns. */
export const evalRunsByScenarioKey = (workspace: string, agent: string, versionId: number) =>
	[...EVAL_RUNS_ROOT, 'byScenario', workspace, agent, versionId] as const;

export async function fetchEvalRunsByScenario(workspace: string, agent: string, versionId: number): Promise<Map<number, EvalReportRow>> {
	const res = await fetch(`/api/${workspace}/${agent}/versions/${versionId}/evals?scope=all`);
	if (!res.ok) throw new Error(`Eval runs request failed (${res.status})`);
	const report = (await res.json()) as EvalReport;
	return new Map(report.results.map((row) => [row.scenarioId, row]));
}

export interface EvalCounts {
	scenarioCount: number;
	versions: Record<number, EvalRunCounts>;
}

export const evalCountsKey = (workspace: string, agent: string) => [...EVAL_RUNS_ROOT, 'counts', workspace, agent] as const;

export async function fetchEvalCounts(workspace: string, agent: string): Promise<EvalCounts> {
	const res = await fetch(`/api/${workspace}/${agent}/versions/eval-counts`);
	if (!res.ok) throw new Error(`Eval counts request failed (${res.status})`);
	return (await res.json()) as EvalCounts;
}
